import(/* webpackMode: "eager", webpackExports: ["ReactQueryClientProvider"] */ "/root/projects/amazighgroupe/app/ReactQueryProvider.tsx");
;
import(/* webpackMode: "eager" */ "/root/projects/amazighgroupe/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Plus_Jakarta_Sans\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"jakarta\"}");
;
import(/* webpackMode: "eager" */ "/root/projects/amazighgroupe/styles/general.css");
;
import(/* webpackMode: "eager" */ "/root/projects/amazighgroupe/styles/globals.css");
